"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
require("./InfoTooltip.css");
var _Tooltip = require("../Tooltip");
var _Icons = require("../Icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var InfoTooltip = _ref => {
  var content = _ref.content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-info-tooltip"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    content: content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-info-tooltip-tile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-info-tooltip-tile-center"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IconHelpCircle, {
    size: '1rem'
  })))));
};
exports.InfoTooltip = InfoTooltip;
//# sourceMappingURL=InfoTooltip.js.map